module.exports = __webpack_public_path__ + "img/bus_marker_track.43a7c921.png";